import type { HTMLAttributes, ReactNode } from 'react';
import styles from './Panel.module.css';

interface PanelProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  interactive?: boolean;
  flush?: boolean;
  children?: ReactNode;
}

/** Glass surface used for every content block in the app. */
export function Panel({
  title,
  subtitle,
  actions,
  interactive = false,
  flush = false,
  className,
  children,
  ...rest
}: PanelProps) {
  const classes = [
    styles.panel,
    interactive ? styles.interactive : '',
    flush ? styles.flush : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} {...rest}>
      {(title || actions) && (
        <header className={styles.header}>
          <div className={styles.titleGroup}>
            {title && <h2 className={styles.title}>{title}</h2>}
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
          </div>
          {actions && <div className={styles.actions}>{actions}</div>}
        </header>
      )}
      {children}
    </div>
  );
}
